<template>
  <div>
    <div class="member-arrange-sta">
      <span class="member-arrange-sta_item">
        已排课次：{{ statistics.arrange_times }}
      </span>
      <span class="member-arrange-sta_item">
        已上课次：{{ statistics.confirm_times }}
      </span>
      <span class="member-arrange-sta_item">
        请假课次：{{ statistics.leave_times }}
      </span>
    </div>
    <div class="member-arrange-search">
      <span class="member-arrange-search_label">课次状态：</span>
      <EnumSelect
        type="ArrangeStatus"
        class="member-arrange-search_select"
        v-model="search.times_status"
      ></EnumSelect>
      <span class="member-arrange-search_label">上课方式：</span>
      <EnumSelect
        type="TeachingType"
        class="member-arrange-search_select"
        :style="{ marginRight: type == 2 ? '36px' : '10px' }"
        v-model="search.class_type"
      ></EnumSelect>
      <template v-if="type == 2">
        <span class="member-arrange-search_label">班课名称：</span>
        <FormSelect
          url="/api/app/arrange/class"
          nameKey="class_name"
          class="member-arrange-search_select class_method"
          v-model="search.class_id"
        ></FormSelect>
      </template>
      <el-button
        class="member-arrange-search_button"
        type="primary"
        @click="onSearch(0)"
      >
        搜索
      </el-button>
      <el-button
        class="member-arrange-search_button"
        type="default"
        @click="onSearch(1)"
      >
        重置
      </el-button>
    </div>
    <list
      ref="list"
      class="list"
      url="/api/app/arrange/list"
      :search="search"
      @page-load="onListLoad"
    >
      <template v-slot="{ list }">
        <MemberArrangeItem
          v-for="item in list"
          :key="item.student_times_id"
          :item="item"
          :type="type"
          :arrange_type="arrange_type"
          @leave="onLeave"
        ></MemberArrangeItem>
        <EmptyNew v-if="list.length == 0" title="暂无数据"></EmptyNew>
      </template>
    </list>
  </div>
</template>
<script>
import MemberArrangeItem from "./MemberArrangeItem.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";
import EmptyNew from "@/components/EmptyNew.vue";

export default {
  name: "MemberArrange",
  components: { MemberArrangeItem, EmptyNew },
  props: {
    type: {
      type: Number,
    },
    arrange_type: {
      default: "",
    },
  },
  data() {
    return {
      statistics: {},
      search: {
        type: this.type,
        times_status: "",
        arrange_type: this.arrange_type,
        class_type: "",
        class_id: "",
      },
      list: [],
    };
  },
  watch: {
    $route() {
      this.search.type = this.type;
      this.refresh();
    },
    arrange_type() {
      this.search.arrange_type = this.arrange_type;
    },
  },
  created() {
    this.getSta();
  },
  methods: {
    onListLoad() {
      triggerLoaded(this);
    },
    async refresh() {
      this.getSta();
      this.onSearch(1);
    },
    async getSta() {
      this.statistics = await this.$http.get(
        "/api/app/arrange/num/" + this.type,
        {
          arrange_type: this.arrange_type,
        },
      );
    },
    onSearch(reset) {
      if (reset) {
        this.search.times_status = "";
        this.search.class_type = "";
        this.search.class_id = "";
      }
      this.$refs.list.searchRefresh();
    },
    onLeave() {
      this.$refs.list.refresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.member-arrange-sta {
  height: 14px;
  font-size: 14px;
  color: #666666;
  line-height: 14px;
}
.member-arrange-sta_item {
  margin-right: 50px;
}
.member-arrange-search {
  margin: 21px 0 23px 0;
}
.member-arrange-search_select {
  width: 150px;
  margin-right: 36px;
  /deep/ {
    .el-input__inner,
    .el-input__icon {
      height: 32px;
      line-height: 32px;
    }
  }
}
.class_method {
  margin-right: 10px;
}
.member-arrange-search_label {
  font-size: 14px;
  color: #666666;
  line-height: 14px;
}
.member-arrange-search_button {
  padding: 8px 15px;
}
</style>
